
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M826.142 257.214c0-40.319-32.685-73.006-73.006-73.006-54.755 0-73.006 32.687-73.006 73.006 0 40.321 32.685 73.008 73.006 73.008s73.006-32.687 73.006-73.008zM668.355 438.554c-40.321 0-73.007 32.687-73.007 73.006 0 40.32 4.425 73.008 44.746 73.008 84.782 0 101.267-32.687 101.267-73.008 0-40.32-32.685-73.006-73.006-73.006zM498.79 415.004c40.321 0 66.157-5.013 73.006-44.747 11.776-68.296-32.685-101.267-73.006-101.267s-73.006 32.688-73.006 73.007c.001 40.32 32.686 73.007 73.006 73.007zM272.707 415.004c40.32 0 73.006-32.687 73.006-73.007 0-40.32 0-73.007-73.006-73.007-40.321 0-73.007 32.688-73.007 73.007 0 40.32 32.686 73.007 73.007 73.007zM260.93 568.08c0-40.319-14.718-73.006-73.006-73.006-40.32 0-73.006 32.687-73.006 73.006 0 40.321 32.685 73.009 73.006 73.009s73.007-32.688 73.007-73.009zM272.707 692.899c-40.321 0-73.007 13.542-73.007 73.006 0 40.32 32.686 73.008 73.007 73.008s73.006-32.687 73.006-73.008c0-40.32-32.685-73.006-73.006-73.006zM583.572 664.638c-40.32 0-101.157.758-90.669 73.007 10.598 73.007 50.348 73.007 90.67 73.007 40.32 0 73.006-32.687 73.006-73.007 0-40.32-32.685-73.007-73.007-73.007zM837.918 664.638c-40.321 0-73.006 32.688-73.006 73.007 0 40.32 18.25 73.007 73.006 73.007 40.32 0 73.006-32.687 73.006-73.007 0-40.32-32.685-73.007-73.006-73.007zM414.01 517.449c-58.288 0-78.896 35.322-78.896 78.893 0 43.572 35.322 78.895 78.895 78.895s78.895-35.322 78.895-78.895c0-43.571-17.075-78.893-78.895-78.893z","fill":"#fff"}})])
          )
        }
      }
    